import axios from 'axios';
import Keycloak from 'keycloak-js';
import React from 'react';

export const axiosDefaults = (
  keycloak: Keycloak.KeycloakInstance,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>
): void => {
  axios.defaults.headers.common = {
    Authorization: `Bearer ${keycloak.token}`
  };
  axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

  axios.interceptors.request.use(
    (config) => {
      setLoading(true);
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (config) => {
      setLoading(false);
      return config;
    },
    (error) => {
      setLoading(false);
      if (error.response && error.response.status === 401) {
        keycloak.logout();
      }
      setErrorMessage(error.response?.data?.message);
      return Promise.reject(error);
    }
  );
};
